<template>
    <div class="root">
        <div class="hh-profile-container margin-top-50">
            <div class="panel panel-default" ref="top">
                <div class="container-fluid">

                    <div v-if="isLoading" class="section-body margin-top-50 margin-bottom-50">
                        <div class="row section margin-top-10">
                            <div class="col-sm-12 section-title">
                                <h1 class="text-center text-normal text-capitalize">
                                    Contact Information
                                </h1>
                            </div>
                        </div>
                        <LoadingAnimation/>
                    </div>

                    <form action="#"
                          @submit.prevent="submitForm"
                          class="form"
                    >
                        <div class="section-body margin-bottom-50" v-if="dataAnalysed">

                            <div v-show="!isLoading" class="address-wrapper" ref="BillingAddress">
                                <div class="row">
                                    <div class="col-sm-12">
                                        <h3 class="text-left text-normal">
                                            Billing Address
                                        </h3>
                                    </div>
                                    <div class="col-sm-12" v-if="contactInformationErrors.has('internalError')">
                                        <div class="text-left text-danger">
                                            There was an error processing your contact information. Please try again
                                            later.
                                        </div>
                                    </div>
                                </div>
                                <div class="margin-top-20 margin-bottom-20">
                                    <Address ref="billingAddressComponent"
                                             :user-data="mappedBillingAddressData"
                                             :static-data="staticData"
                                             :edit-mode="true"
                                             :errors="addressErrors('billing')"
                                             @componentLoading="componentLoading"
                                    />
                                </div>
                            </div>
                                    <div class="row hh-form-btn-wrapper margin-bottom-20 margin-top-20" v-if="!loading">
                                      <div class="form-group col-sm-6">
                                        <button type="button" v-on:click="backAction"
                                                class="btn hh-btn back-btn" name="Cancel">
                                          Cancel
                                        </button>
                                      </div>
                                      <div class="form-group col-sm-6">
                                        <button type="submit" :disabled="!formReady"
                                                class="btn save-btn hh-btn-green" name="Save changes">
                                          Save Changes
                                        </button>
                                      </div>
                                    </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  import Address from '../../components/form/Address'
  import Alert from '../../components/form/elements/Alert'
  import LoadingAnimation from '../../components/LoadingAnimation'
  import Form from '../../plugins/Form'
  import { scrollTo } from '../../utils/componentHelper'

  export default {
    name: 'ContactInformationView',

    components: {
      Address,
      Alert,
      LoadingAnimation,
    },

    props: {},

    beforeMount () {
      if (_.isEmpty(this.profileData)) {
        this.fetchData().then(() => {
          this.analyseUserData()
        })
      } else {
        this.analyseUserData()
      }
    },

    mounted () {
      this.loading = false
      scrollTo(this.$refs['top'])
    },

    data: () => {
      return {
        dataAnalysed: false,
        isPaymentFormReady: true,
        config: {},
        loading: true,
        userData: {
          billing_first_name: null,
          billing_last_name: null,
          billing_address_1: null,
          billing_address_2: null,
          billing_country: 'United States',
          billing_state: null,
          billing_zip: null,
          informationType: 'ContactInformation',
        },
        componentsLoadingStatus: {
          ContactInformation: true,
        },
        staticData: null,
      }
    },

    methods: {
      ...mapActions('profile', ['fetchData', 'storeInformation']),

      componentLoading (componentName, value) {
        this.componentsLoadingStatus[componentName] = value
      },

      analyseUserData () {
        if (!_.isEmpty(this.profileData)) {
          this.fillUserData()
          this.fillConfigData()
          this.dataAnalysed = true
        }
      },

      fillUserData () {
        this.fillContactInformation()
        this.fillStaticData()
      },

      fillContactInformation () {
        if (!_.isEmpty(this.profileData.data.relations.contact)) {
          this.userData = { ...this.userData, ...this.profileData.data.relations.contact.data.attributes }
        }
      },

      fillStaticData () {
        if (!_.isEmpty(this.profileData.data.staticData)) {
          this.staticData = this.profileData.data.staticData
        }
      },

      fillConfigData () {
        if (!_.isEmpty(this.profileData.config)) {
          this.config = this.profileData.config
        }
      },

      backAction () {
        this.$router.back()
      },

      submitForm () {
        this.isPaymentFormReady = false
        this.loading = true

        if (this.processFormData()) {
          this.sendFormData()
        }

        return true
      },

      processFormData () {
        this.fillAddressData(this.mappedBillingAddressData, 'billing')

        return true
      },

      sendFormData () {
        this.storeInformation(this.userData).then(() => {
          if (this.contactInformationStatus === 'success') {
            this.$store.dispatch('profile/fetchData').then(() => {
              this.$store.commit('setAlert', {
                message: 'Profile information updated.',
                type: 'bg-success'
              })
              this.isPaymentFormReady = true
              this.loading = false
              this.$router.push({ name: 'profile' })
            })
          } else {
            this.isPaymentFormReady = true
            this.loading = false
          }
        })
      },

      fillAddressData (data, type) {
        this.userData[`${type}_first_name`] = data.firstName
        this.userData[`${type}_last_name`] = data.lastName
        this.userData[`${type}_address_1`] = data.address1
        this.userData[`${type}_address_2`] = data.address2
        this.userData[`${type}_country`] = data.country
        this.userData[`${type}_city`] = data.city
        this.userData[`${type}_state`] = data.state
        this.userData[`${type}_zip`] = data.zip
      },

      mapAddressData (data, prefix) {
        return {
          'firstName': data[`${prefix}_first_name`],
          'lastName': data[`${prefix}_last_name`],
          'address1': data[`${prefix}_address_1`],
          'address2': data[`${prefix}_address_2`],
          'country': data[`${prefix}_country`],
          'city': data[`${prefix}_city`],
          'state': data[`${prefix}_state`],
          'zip': data[`${prefix}_zip`],
        }
      },

      addressErrors (type) {
        let errorObject = new Form({}).errors

        if (!this.contactInformationErrors.any()) {
          return errorObject
        }

        let billingErrors = this.mapAddressData(this.contactInformationErrors.errors, type)
        errorObject.record(billingErrors)
        return errorObject
      },

    },

    computed: {
      ...mapGetters('profile', ['profileData']),
      ...mapGetters(['alert']),

      isLoading () {
        for (let component in this.componentsLoadingStatus) {
          if (this.componentsLoadingStatus[component]) {
            return true
          }
        }

        return this.loading
      },

      formReady () {
        return this.isPaymentFormReady === true
      },

      contactInformationStatus: {
        get () {
          return this.$store.getters['profile/storeInformationStatus'](this.userData.informationType)
        },
      },

      contactInformationErrors: {
        get () {
          return this.$store.getters['profile/storeInformationErrors'](this.userData.informationType)
        },
      },

      mappedBillingAddressData () {
        return this.mapAddressData(this.userData, 'billing')
      },

    },
  }
</script>

<style lang="scss" scoped>
    .root::v-deep {
        @import '../../../style/pages/profile';
    }

    h1 {
      font-family: Circular Std;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 33px;
      color: #000000 !important;
    }

    h3 {
      font-family: Circular Std;
      font-style: normal;
      font-weight: bold;
      font-size: 26px;
      line-height: 33px;
      letter-spacing: -0.01em;  
      color: #000000;
    }

     @media screen and (max-width: 767px) {
     h3 {
       font-size: 21px !important;
     }
    
  }
</style>